import React, { ChangeEvent } from 'react';
import { Tab, Tabs } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { CHAT_SCOPE } from 'src/contexts/assistant/constants';
import {
    ASSISTANT_SECTION,
    TAssistantSection,
} from 'src/modules/assistant/constants/widget';
import { TChatScope } from 'src/contexts/assistant/types';

const useStyles = makeStyles((theme: Theme) => ({
    tabs: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        flexShrink: 0,
    },
}));

type TTabValue = TChatScope | typeof ASSISTANT_SECTION.WORKING_LEADS;

interface AssistantTabsProps {
    section: TAssistantSection;
    scope: TChatScope;
    showLeadTab: boolean;
    onSelectChat: (scope: TChatScope) => void;
    onSelectWorkingLeads: () => void;
}

export const AssistantTabs = ({
    section,
    scope,
    showLeadTab,
    onSelectChat,
    onSelectWorkingLeads,
}: AssistantTabsProps) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const value: TTabValue =
        section === ASSISTANT_SECTION.WORKING_LEADS
            ? ASSISTANT_SECTION.WORKING_LEADS
            : scope;

    const handleChange = (_: ChangeEvent<unknown>, next: TTabValue) => {
        if (next === ASSISTANT_SECTION.WORKING_LEADS) onSelectWorkingLeads();
        else onSelectChat(next);
    };

    return (
        <Tabs
            aria-label={t('Assistant.ChatType')}
            className={classes.tabs}
            indicatorColor="primary"
            onChange={handleChange}
            textColor="primary"
            value={value}
            variant="fullWidth"
        >
            <Tab
                label={t('Assistant.GeneralChat')}
                value={CHAT_SCOPE.GENERAL}
            />
            {showLeadTab && (
                <Tab label={t('Assistant.LeadChat')} value={CHAT_SCOPE.LEAD} />
            )}
            <Tab
                label={t('Assistant.WorkingLeadsTab')}
                value={ASSISTANT_SECTION.WORKING_LEADS}
            />
        </Tabs>
    );
};
